'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from 'react';
import type { PrV2ChapterEntry } from '../lib/pr-v2-chapter-mode';
import { getPrV2GroupElementId } from '../../file-tree-v2/pr-v2-file-tree-utils';
type PrV2GroupJump = {
  groupId: string;
  comparisonKey: string | null;
  renderedFilenames: string[];
};
type UsePrV2CurrentGroupParams = {
  entries: PrV2ChapterEntry[];
  activeFilename: string | null;
  comparisonKey: string | null;
  renderedFilenames: string[];
};

/**
 * The group the group card shows: the one that holds the active file, else the first one.
 */
export function usePrV2CurrentGroup(t0) {
  const $ = _c(10);
  const {
    entries,
    activeFilename,
    comparisonKey,
    renderedFilenames
  } = t0;
  const [groupJump, setGroupJump] = useState(null);
  if (groupJump !== null && (activeFilename !== null || groupJump.comparisonKey !== comparisonKey || groupJump.renderedFilenames !== renderedFilenames)) {
    setGroupJump(null);
  }
  let t1;
  if ($[0] !== comparisonKey || $[1] !== renderedFilenames) {
    t1 = groupId => setGroupJump({
      groupId,
      comparisonKey,
      renderedFilenames
    });
    $[0] = comparisonKey;
    $[1] = renderedFilenames;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const markGroupJump = t1;
  let t2;
  if ($[3] !== activeFilename || $[4] !== entries || $[5] !== groupJump?.groupId) {
    t2 = entries.find(t3 => {
      const {
        group
      } = t3;
      return activeFilename === null ? getPrV2GroupElementId(group.groupName, group.groupOrder) === groupJump?.groupId : group.files.some(file => file.filename === activeFilename);
    }) ?? entries[0];
    $[3] = activeFilename;
    $[4] = entries;
    $[5] = groupJump?.groupId;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const currentGroupEntry = t2;
  let t3;
  if ($[7] !== currentGroupEntry || $[8] !== markGroupJump) {
    t3 = {
      currentGroupEntry,
      markGroupJump
    };
    $[7] = currentGroupEntry;
    $[8] = markGroupJump;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}